<app-medias-list
  [medias]="medias.items"
  infiniteScroll
  (scrolled)="loadMore()"
   display="short"
></app-medias-list>
